import { render, staticRenderFns } from "./TempConfigFormModalOld.vue?vue&type=template&id=3e64e43c&scoped=true"
import script from "./TempConfigFormModalOld.vue?vue&type=script&lang=js"
export * from "./TempConfigFormModalOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e64e43c",
  null
  
)

export default component.exports